export const UI = {
  en: {
    nav: {
      about: "About",
      expertise: "Expertise",
      cases: "Case Studies",
      experience: "Experience",
      certs: "Certifications",
    },
    navCta: "Let's Discuss Opportunities",
    available: "Open to Opportunities",
    heroCtaPrimary: "Let's Discuss Opportunities",
    heroCtaSecondary: "Explore My Work",
    heroChipExperience: "4 Years Experience",
    heroChipPlatforms: "Meta · Google · Shopee · TikTok",
    summaryEyebrow: "Professional Summary",
    summaryTitle: "Data-first. Revenue-focused.",
    summaryPoints: [
      "4 years across marketplace management, paid advertising, SEO & SEM, web development and branding",
      "Every decision starts from a dashboard read, not a hunch",
      "Cross-channel coordination, budget planning and team leadership",
    ],
    quoteLabel: "My philosophy",
    kpiEyebrow: "KPI Highlights",
    kpiTitle: "Results, in numbers",
    kpiNote: "Every figure on this page comes from real campaign dashboards — nothing is embellished.",
    expertiseEyebrow: "Expertise",
    expertiseTitle: "Capabilities that move the needle",
    expertiseNote: "AI & automation work as a support layer — the core is performance.",
    supportBadge: "Support skill",
    casesEyebrow: "Featured Case Studies",
    casesTitle: "Proof over promises",
    channels: "Channels",
    viewCase: "View Case Study",
    modal: {
      objective: "Objective",
      strategy: "Strategy",
      execution: "Execution",
      result: "Result",
      challenge: "The challenge",
      keyMetrics: "Key metrics",
      growth: "Growth",
    },
    expEyebrow: "Career Experience",
    expTitle: "The road so far",
    certEyebrow: "Certifications",
    certTitle: "Credentials",
    verify: "Verify credential",
    contactEyebrow: "Contact",
    contactTitle: "Have a Growth Challenge? Let's Talk.",
    contactBody:
      "Whether it's a full-time role, a freelance project or a growth problem that needs solving — my inbox is open. Let's talk about how data and strategy can move your numbers.",
    whatsappCta: "Chat on WhatsApp",
    emailCta: "Or email me",
    footerTagline: "Digital Marketing & Performance Growth",
    rights: "All rights reserved.",
    adminLink: "Admin",
  },
  id: {
    nav: {
      about: "Tentang Saya",
      expertise: "Keahlian",
      cases: "Studi Kasus",
      experience: "Pengalaman",
      certs: "Sertifikasi",
    },
    navCta: "Diskusi Peluang Karier",
    available: "Terbuka untuk Peluang",
    heroCtaPrimary: "Diskusi Peluang Karier",
    heroCtaSecondary: "Lihat Hasil Kerja Saya",
    heroChipExperience: "4 Tahun Pengalaman",
    heroChipPlatforms: "Meta · Google · Shopee · TikTok",
    summaryEyebrow: "Ringkasan Profesional",
    summaryTitle: "Berbasis Data. Berfokus pada Revenue.",
    summaryPoints: [
      "4 tahun di marketplace management, iklan berbayar, SEO & SEM, pengembangan website, dan branding",
      "Setiap keputusan dimulai dari pembacaan dashboard, bukan sekadar perasaan",
      "Koordination lintas channel, penyusunan budget, dan kepemimpinan tim",
    ],
    quoteLabel: "Filosofi saya",
    kpiEyebrow: "Sorotan KPI",
    kpiTitle: "Hasil dalam Angka",
    kpiNote: "Setiap angka di halaman ini berasal dari dashboard kampanye nyata — tanpa embel-embel.",
    expertiseEyebrow: "Keahlian",
    expertiseTitle: "Kemampuan yang Menggerakkan Angka",
    expertiseNote: "AI & automation berperan sebagai lapisan pendukung — intinya tetap performa.",
    supportBadge: "Keahlian pendukung",
    casesEyebrow: "Studi Kasus Utama",
    casesTitle: "Bukti, Bukan Janji",
    channels: "Channel",
    viewCase: "Lihat Studi Kasus",
    modal: {
      objective: "Tujuan",
      strategy: "Strategi",
      execution: "Eksekusi",
      result: "Hasil",
      challenge: "Tantangan",
      keyMetrics: "Metrik utama",
      growth: "Pertumbuhan",
    },
    expEyebrow: "Pengalaman Kerja",
    expTitle: "Perjalanan Sejauh Ini",
    certEyebrow: "Sertifikasi",
    certTitle: "Kredensial",
    verify: "Verifikasi kredensial",
    contactEyebrow: "Kontak",
    contactTitle: "Punya Tantangan Pertumbuhan? Ayo Bicara.",
    contactBody:
      "Baik itu posisi full-time, proyek freelance, atau masalah pertumbuhan yang perlu dipecahkan — saya siap berdiskusi. Mari bicara bagaimana data dan strategi bisa menggerakkan angka Anda.",
    whatsappCta: "Chat via WhatsApp",
    emailCta: "Atau email saya",
    footerTagline: "Digital Marketing & Performance Growth",
    rights: "Hak cipta dilindungi.",
    adminLink: "Admin",
  },
};
